import React from 'react';
import { Modal, Form, Input, Radio } from 'antd';

const { TextArea } = Input;

interface ApprovalActionModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (action: 'APPROVE' | 'REJECT', comment: string) => void;
  title?: string;
  defaultAction?: 'APPROVE' | 'REJECT';
  loading?: boolean;
}

export const ApprovalActionModal: React.FC<ApprovalActionModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  title = 'Quyết định Duyệt Claim',
  defaultAction = 'APPROVE',
  loading = false,
}) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (visible) {
      form.setFieldsValue({ action: defaultAction, comment: '' });
    }
  }, [visible, defaultAction, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values.action, values.comment);
    } catch (err) {
      // Validation error
    }
  };

  return (
    <Modal
      title={title}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Xác nhận"
      cancelText="Hủy"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item name="action" label="Quyết định phê duyệt" rules={[{ required: true }]}>
          <Form.Item name="action" noStyle>
            {({ getFieldValue, setFieldsValue }) => {
              const currentAction = getFieldValue('action');
              return (
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    type="button"
                    onClick={() => setFieldsValue({ action: 'APPROVE' })}
                    style={{
                      flex: 1,
                      padding: '10px 16px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: 600,
                      transition: 'all 0.2s ease',
                      border:
                        currentAction === 'APPROVE' ? '2px solid #52c41a' : '1px solid #d9d9d9',
                      backgroundColor: currentAction === 'APPROVE' ? '#52c41a' : '#f6ffed',
                      color: currentAction === 'APPROVE' ? '#ffffff' : '#389e0d',
                      boxShadow:
                        currentAction === 'APPROVE' ? '0 2px 6px rgba(82, 196, 26, 0.35)' : 'none',
                    }}
                  >
                    ✓ Duyệt (Approve)
                  </button>

                  <button
                    type="button"
                    onClick={() => setFieldsValue({ action: 'REJECT' })}
                    style={{
                      flex: 1,
                      padding: '10px 16px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: 600,
                      transition: 'all 0.2s ease',
                      border:
                        currentAction === 'REJECT' ? '2px solid #ff4d4f' : '1px solid #d9d9d9',
                      backgroundColor: currentAction === 'REJECT' ? '#ff4d4f' : '#fff2f0',
                      color: currentAction === 'REJECT' ? '#ffffff' : '#cf1322',
                      boxShadow:
                        currentAction === 'REJECT' ? '0 2px 6px rgba(255, 77, 79, 0.35)' : 'none',
                    }}
                  >
                    ✕ Từ chối (Reject)
                  </button>
                </div>
              );
            }}
          </Form.Item>
        </Form.Item>

        <Form.Item name="comment" label="Ghi chú / Lý do">
          <TextArea rows={3} placeholder="Nhập lý do hoặc nhận xét (nếu có)..." />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ApprovalActionModal;
